export default {"src":"/_next/static/media/google-play-badge.54863944.svg","height":1604,"width":5436};